module.exports = __webpack_public_path__ + "static/img/aiqx.8149a0c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/aiqx.png
// module id = z/2z
// module chunks = 0